<template>
    <div>
        <h1>Unmapped PO</h1>
        <VendorForm :vendorName="vendorName" :clientName="clientName" :clientId="clientId" :vendorTotalSpend="vendorTotalSpend" :vendorId="vendorId" type="unmappedAP" ref="vendorForm" />
        <div class="mt-5">
            <VendorAllocation :vendorAllocation="vendorAllocation" :vendorTotalSpend="vendorTotalSpend" ref="vendorAllocation" />
        </div>
    </div>
</template>

<script>
import { storeData } from "../../../store";
import VendorForm from "./VendorForm";
import VendorAllocation from "./VendorAllocation";
import { UNMAPPED_PO } from "../vendorQueries";
export default {
    name: "unmappedPo",
    components: {
        VendorAllocation,
        VendorForm
    },
    data() {
        return {
            vendorId: storeData.vendorData.id,
            vendorName: "",
            clientName: "",
            clientId: "",
            vendorAllocation: [],
            vendorTotalSpend: "",
        };
    },
    mounted() {
        this.fetchUnmappedPo();
    },
    methods: {
        async fetchUnmappedPo() {
            try {
                const { data } = await this.$apollo.query({
                    query: UNMAPPED_PO,
                    variables: {
                        vendor_identifier: this.vendorId,
                    },
                });
                console.log("data-po", data);
                this.vendorName = data.spendmd_db_get_vendor_name[0].vendor_name;
                this.clientName = data.spendmd_db_get_vendor_name[0].client_name;
                this.clientId = data.spendmd_db_get_vendor_name[0].client_id;
                this.vendorAllocation = data.spendmd_db_po_unmapped_aggregate.nodes;
                this.vendorTotalSpend = data.spendmd_db_po_unmapped_aggregate.aggregate.sum.total_spend;
                console.log("vendorAllocation", this.vendorTotalSpend);

            } catch (err) {
                console.error("Error fetching unmapped PO data:", err);
            }
        },
        getVendorAllocation() {
            const vendorAllocation = this.$refs.vendorAllocation.getVendorAllocations();
            return vendorAllocation;
        },
        getVendorForm() {
            const vendorForm = this.$refs.vendorForm.getVendorData();
            return vendorForm;
        }
    },
};
</script>
